export const PHI_BLUR_CLASS = 'phi-blur';

/**
 * Why PHI is blurred. The screenshot precursor and the manual "Hide PHI" toggle each hold their own
 * reason, so releasing a screenshot chord never unblurs a screen someone chose to hide.
 */
export type PhiBlurSource = 'precursor' | 'manual';

const activeSources = new Set<PhiBlurSource>();

type Listener = () => void;

const listeners = new Set<Listener>();

/**
 * Writes the class straight onto <html> rather than through React state, so the blur lands on the
 * next paint instead of after a render.
 */
export const setPhiBlurSource = (source: PhiBlurSource, active: boolean) => {
  if (activeSources.has(source) === active) return;

  if (active) {
    activeSources.add(source);
  } else {
    activeSources.delete(source);
  }

  document.documentElement.classList.toggle(PHI_BLUR_CLASS, activeSources.size > 0);

  // The class is already on the page; React subscribers (the nav button) catch up after it.
  listeners.forEach((listener) => listener());
};

export const isPhiBlurSourceActive = (source: PhiBlurSource) => activeSources.has(source);

export const subscribePhiBlur = (listener: Listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const isPhiBlurred = () => document.documentElement.classList.contains(PHI_BLUR_CLASS);
